import { render, staticRenderFns } from "./WechatOauthMiddlePage.vue?vue&type=template&id=3a16d387&"
import script from "./WechatOauthMiddlePage.vue?vue&type=script&lang=ts&"
export * from "./WechatOauthMiddlePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports